import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import CreditPurchase from "apps/payment/components/CreditPurchase";

import {
	setForm,
	handleFormBlur,
	confirmPurchaseNewCard,
} from "ducks/payment";

export const mapStateToProps = (state) => {
	const { payment } = state;

	return payment;
};

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			setForm,
			handleFormBlur,
			confirmPurchaseNewCard,
		},
		dispatch,
	);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(CreditPurchase);



// WEBPACK FOOTER //
// ./src/apps/payment/containers/CreditPurchase/index.jsx